import { render, staticRenderFns } from "./EditIconButton.vue?vue&type=template&id=dae21c96&"
import script from "./EditIconButton.vue?vue&type=script&lang=js&"
export * from "./EditIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports